const mockCoursesResponse = {
    items: [
        {
            courseId: 'COURSE-001',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
            description: 'Introduction to modern wound care practices',
            link: 'https://absorb.example.com/courses/COURSE-001',
            timestampUtc: '2025-01-01T10:30:00Z',
            isActive: true,
            categoryName: 'Wound Care',
            courseType: 'Clinical',
            learnerTime: '8 min',
            countryCourse: 'en-US',
            tags: ['beginner', 'nursing'],
            enrollNowText: 'Enroll now Text',
            registerLabelText: 'Testin CTa Label Text',
            registerAbsorbUrl: 'google.com/',
            imageUrl: 'https://www.convatec.com/marketingzone/mediaimage/?id=aa875fc3-7d4e-4435-9b9f-b6f14e01db46',
        },
        {
            courseId: 'COURSE-002',
            title: 'Advanced Ostomy Care',
            description: '<p style="color: rgba(65, 65, 65, 1); font-family: sans-serif; font-size: 14px; font-style: normal; font-weight: 400; background-color: rgba(255, 255, 255, 1)">Biofilm can be defined as microbial cells adherent to a living or non-living surface, which are embedded within a self-produced matrix of extra-cellular polymeric substances (EPS). Biofilm provides tolerance to antimicrobial agents and can result in persistent inflammation and infection.</p><p style="color: rgba(65, 65, 65, 1); font-family: sans-serif; font-size: 14px; font-style: normal; font-weight: 400; background-color: rgba(255, 255, 255, 1)"><strong style="font-weight: 700">Learning Outcomes:</strong></p><p style="color: rgba(65, 65, 65, 1); font-family: sans-serif; font-size: 14px; font-style: normal; font-weight: 400; background-color: rgba(255, 255, 255, 1)">This video will explore some foundational questions regarding biofilm and its characteristics, including:</p><ol style="color: rgba(65, 65, 65, 1); font-family: sans-serif; font-size: 14px; font-style: normal; font-weight: 400; background-color: rgba(255, 255, 255, 1)"><li>What is Biofilm?</li><li>How does biofilm form?</li><li>Why is biofilm so difficult to eradicate?</li><li>How does biofilm act as a protective barrier against action of antiseptics, antibiotics and the host\'s immune system?</li><li>How does biofilm spread?</li><li>How quickly and aggressively does biofilm reform?</li><li>How to identify biofilm?</li></ol>',
            link: 'https://absorb.example.com/courses/COURSE-002',
            timestampUtc: '2025-01-05T12:00:00Z',
            isActive: true,
            categoryName: 'Ostomy',
            courseType: 'OnlineCourse',
            learnerTime: 'Not Informed',
            markets: ['US'],
            tags: ['ostomy', 'advanced'],
            enrollNowText: 'Enroll now 2',
            registerLabelText: 'Testin CTa Label 2',
            registerAbsorbUrl: 'google.com/',
        },
        {
            courseId: 'COURSE-003',
            title: 'Skin Integrity Essentials',
            description: 'Learn prevention strategies for skin breakdown',
            link: 'https://absorb.example.com/courses/COURSE-003',
            timestampUtc: '2025-02-01T09:15:00Z',
            isActive: true,
            categoryName: 'Skin Care',
            courseType: 'Clinical',
            learnerTime: '5 min',
            countryCourse: 'en-US',
            tags: ['skin', 'prevention'],
            enrollNowText: 'Enroll now',
            registerLabelText: 'Testin CTa Label',
            registerAbsorbUrl: 'google.com',
        },
        ...Array.from({ length: 17 }, (_item, index) => ({
            courseId: `COURSE-${index + 4}`,
            title: `Test Course ${index + 4}`,
            description: `This is a sample course number ${index + 4}`,
            link: 'https://absorb.example.com',
            timestampUtc: '2025-03-01T00:00:00Z',
            isActive: true,
            categoryName: index % 2 === 0 ? 'Wound Care' : 'Ostomy',
            courseType: index % 3 === 0 ? 'Clinical' : 'Advanced',
            learnerTime: `${(index % 10) + 1} min`,
            countryCourse: 'en-US',
            tags: index % 2 === 0 ? ['tagA'] : ['tagB'],
            enrollNowText: 'Enroll now',
            registerLabelText: 'Testin CTa Label',
            registerAbsorbUrl: 'google.com',
        })),
    ],
    totalItems: 20,
};

export { mockCoursesResponse };
